import React from 'react';
import {Box, Typography} from '@mui/material';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import {useHistory} from 'react-router-dom';

const ORANGE = '#FF6900';

/**
 * Generic titled section card used across National Dashboard pages.
 *
 * Props:
 *   title    {string}    – card heading
 *   linkTo   {string}    – when set, the title becomes a clickable "→" link
 *                          to another Baseline Results page, e.g. "Top Child
 *                          Cyber Risks" → the Cyber Risks page, per the
 *                          deck's own "→ Cyber Risks" annotation.
 *   children {ReactNode} – card body
 *   sx       {object}    – additional MUI sx overrides
 */
const SectionCard = ({title, titleRight, linkTo, children, sx = {}}) => {
    const history = useHistory();

    const titleNode = linkTo ? (
        <Box
            onClick={() => history.push(linkTo)}
            sx={{display: 'flex', alignItems: 'center', gap: 0.75, cursor: 'pointer', width: 'fit-content', '&:hover': {textDecoration: 'underline'}}}
        >
            <Typography sx={{fontSize: '15px', fontWeight: 700, color: '#111827'}}>{title}</Typography>
            <ArrowForwardIcon style={{fontSize: 16, color: ORANGE}}/>
        </Box>
    ) : (
        <Typography sx={{fontSize: '15px', fontWeight: 700, color: '#111827'}}>{title}</Typography>
    );

    return (
        <Box sx={{
            border: '1px solid var(--brand-border, #E5E7EB)',
            borderRadius: '12px',
            backgroundColor: 'var(--brand-surface, #ffffff)',
            boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
            p: 3,
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            ...sx,
        }}>
            {title && (
                titleRight ? (
                    <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1.5, mb: 2.5}}>
                        {titleNode}
                        {titleRight}
                    </Box>
                ) : (
                    <Box sx={{mb: 2.5}}>{titleNode}</Box>
                )
            )}
            {children}
        </Box>
    );
};

export default SectionCard;
